import React from "react";
import ReactExport from "react-export-excel";
import {
    Button
} from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ReportExport = (props) => {
    const { pccreportdataset } = props;
    return (
        <ExcelFile element={
            <Button sx={{
                mx: 1,
                height: "30px",
                width: "145px",
                marginBottom: "5px",
                marginTop: "-20px",
            }}
                variant="contained"
                startIcon={<GetAppIcon />}> Lab Details </Button>
        }>
            <ExcelSheet data={pccreportdataset} name="Lab Credentials">
                <ExcelColumn label="Trainee Name" value="trainee" style={{ font: { sz: "24", bold: true } }} />
                <ExcelColumn label="Server Name" value="key" />
                <ExcelColumn label="Public Ip" value="public" />
                <ExcelColumn label="Console url" value="console_url" />
                <ExcelColumn label="Instance username" value="instance_username" />
                <ExcelColumn label="Instance password" value="instance_password" />
            </ExcelSheet>
        </ExcelFile>
    );
}


export default ReportExport;